<div class="modal">
  <div class="title-row">
    <div class="title">
      <span class="kbody-huge"><strong>Update Course Status</strong></span>
    </div>
    <mat-icon
      (click)="closeStatusModal()"
      fontSet="material-icons-round"
      class="close"
      >close</mat-icon
    >
  </div>

  <div class="content">
    <span class="kbody-large status-instructions">
      Set the attendance status for this course by selecting an option below.
    </span>

    <label class="kbody-large" for="statusSelect">Select Status</label>
<mat-form-field appearance="fill" class="status-dropdown wide-compact-select">
  <mat-select
    id="statusSelect"
    [(ngModel)]="status"
    placeholder="Select Status"
    [panelClass]="'wide-compact-select-panel'"
  >
    <mat-option *ngFor="let opt of statusOptions" [value]="opt.value">
      {{ opt.label }}
    </mat-option>
  </mat-select>
</mat-form-field>

  <div class="buttons">
    <app-button
      class="kbutton white"
      (click)="closeStatusModal()"
      text="Cancel"
    ></app-button>
    <app-button
      class="kbutton"
      (click)="submitStatus()"
      text="Update Status"
    ></app-button>
  </div>
</div>
